import { Product } from '@spartacus/core';
import { StatusRequest } from '../../../../../core/models/request-status.model';

export enum PRODUCT_COMPARATOR_TYPE {
  FLOATTING = 'FLOATTING',
  CROSS_REFERENCE = 'CROSS_REFERENCE',
}

export interface ProductComparatorFloating {
  products: Product[];
}

export interface ProductComparatorRow {
  code?: string;
  title?: string;
  keySpec?: boolean;
  values?: {
    productCode?: string;
    value?: string;
  }[];
}

export interface ProductComparatorSection {
  code?: string;
  name?: string;
  rows?: ProductComparatorRow[];
}

export interface PComparatorProductsRequest {
  pids?: string; // Products IDs
  pid?: string; // Product ID
  useProductReferences?: string; // Source
}

export interface ProductComparator {
  products?: Product[];
  sections?: ProductComparatorSection[];
}

export interface PComparatorStatusRequest extends StatusRequest {
  pComparator?: ProductComparator;
}
